import { Radio } from "./Radio";

const forms = document.querySelectorAll("form.std-form") as NodeListOf<HTMLFormElement>;

forms.forEach((f) => {
    f.setAttribute("novalidate", "novalidate");
    f.addEventListener("submit", (e) => checkValidity(e, f));
    f.addEventListener("form:next", (e) => checkValidity(e, f));

    f.addEventListener("formdata", (e) => {
        const formData = e.formData;
        Array.from(f.elements).forEach((elm: any) => {
            const name = elm.getAttribute("name");
            if (elm.tagName === "X-CHECKBOX" && elm.checked === false) {
                formData.delete(name);
            }
            if (elm.tagName === "X-RADIO") {
                const value = (
                    [...(f.elements[name] as unknown as RadioNodeList)].filter((r: Radio) => r.checked)[0] as Radio
                ).value;
                formData.delete(name);
                formData.append(name, value);
            }
            if (elm.tagName === "X-DROPDOWN" && elm.multiselect) {
                formData.delete(name);
                Array.from(elm.selectedOptions).forEach((o: { label: string; value: string }) => {
                    formData.append(name, o.value);
                });
            }
            if (elm.tagName === "X-FILE") {
                formData.delete(name);
                Array.from(elm.files).forEach((f: File) => {
                    formData.append(name, f);
                });
            }
        });
    });

    f.addEventListener("reset", () => {
        Array.from(f.elements).forEach((elm: any) => {
            const isCustom = elm.tagName.indexOf("X-") === 0;
            if (isCustom) {
                if (elm.tagName === "X-CHECKBOX") {
                    elm.checked = false;
                } else if (elm.tagName === "X-DROPDOWN") {
                    elm.selectedIndex = -1;
                } else if (elm.tagName === "X-RANGE") {
                    elm.value = elm.getAttribute("min");
                } else {
                    elm.value = "";
                }
                elm.resetValidationState();
            }
        });
    });
});

const checkValidity = (e: Event, form: HTMLFormElement) => {
    const controls: HTMLFormControlsCollection = form.elements;
    const invalidElements = [];
    Array.from(controls).forEach((elm: any) => {
        if ("undefined" !== typeof elm.reportsValidity) elm.reportsValidity = true;
        if (elm.willValidate && !elm.validity.valid) {
            e.preventDefault();
            e.stopImmediatePropagation();
            invalidElements.push(elm);
        }
    });
    if (invalidElements.length) {
        form.dispatchEvent(
            new CustomEvent("invalid", {
                detail: {
                    invalidElements,
                    form: form,
                    originalEvent: e
                }
            })
        );
    }
};
